import { create } from 'zustand';

export const useTicketStore = create((set) => ({
    // ── List state ──────────────────────────────────────────────
    tickets: [],
    loading: false,
    error: null,
    searchParams: {
        page: 1,
        pageSize: 15,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        search: '',
        status: '',
        category: '',
        priority: '',
        slaBreached: ''
    },
    paginationData: {
        total: 0,
        totalPages: 0,
        page: 1,
        pageSize: 15
    },

    // ── Detail state ────────────────────────────────────────────
    selectedTicket: null,
    detailLoading: false,

    // ── Pool & My Pending ───────────────────────────────────────
    poolTickets: [],
    myPendingTickets: [],

    // ── Stats ───────────────────────────────────────────────────
    stats: null,

    // ── Selected tickets for bulk actions ────────────────────────
    selectedTicketIds: [],

    // ── UI State ────────────────────────────────────────────────
    isCreateFormOpen: false,
    isApprovalPanelOpen: false,
    isAssignDialogOpen: false,
    isResolveDialogOpen: false,
    isDelegateDialogOpen: false,
    currentAction: null,

    // ── Setters ─────────────────────────────────────────────────
    setTickets: (tickets) => set({ tickets }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSearchParams: (params) => set((s) => ({ searchParams: { ...s.searchParams, ...params } })),
    setPaginationData: (paginationData) => set({ paginationData }),
    setSelectedTicket: (ticket) => set({ selectedTicket: ticket }),
    setDetailLoading: (detailLoading) => set({ detailLoading }),
    setPoolTickets: (poolTickets) => set({ poolTickets }),
    setMyPendingTickets: (myPendingTickets) => set({ myPendingTickets }),
    setStats: (stats) => set({ stats }),
    setSelectedTicketIds: (ids) => set({ selectedTicketIds: ids }),
    toggleTicketSelection: (id) => set((s) => ({
        selectedTicketIds: s.selectedTicketIds.includes(id)
            ? s.selectedTicketIds.filter(i => i !== id)
            : [...s.selectedTicketIds, id]
    })),
    clearTicketSelection: () => set({ selectedTicketIds: [] }),

    // ── Modal helpers ────────────────────────────────────────────
    openCreateForm: () => set({ isCreateFormOpen: true }),
    closeCreateForm: () => set({ isCreateFormOpen: false }),
    openApprovalPanel: (action) => set({ isApprovalPanelOpen: true, currentAction: action }),
    closeApprovalPanel: () => set({ isApprovalPanelOpen: false, currentAction: null }),
    openAssignDialog: () => set({ isAssignDialogOpen: true }),
    closeAssignDialog: () => set({ isAssignDialogOpen: false }),
    openResolveDialog: () => set({ isResolveDialogOpen: true }),
    closeResolveDialog: () => set({ isResolveDialogOpen: false }),
    openDelegateDialog: () => set({ isDelegateDialogOpen: true }),
    closeDelegateDialog: () => set({ isDelegateDialogOpen: false }),

    // ── Optimistic update ────────────────────────────────────────
    updateTicketInList: (id, patch) => set((s) => ({
        tickets: s.tickets.map(t => (t._id === id || t.id === id) ? { ...t, ...patch } : t)
    }))
}));
